import { render, staticRenderFns } from "./ModalConfirmDoHomework.vue?vue&type=template&id=f2f31b4c&scoped=true"
import script from "./ModalConfirmDoHomework.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDoHomework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f31b4c",
  null
  
)

export default component.exports